import React, { useState } from 'react';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import { stopBackgroundScrolling } from 'common/utils/app.utils';

const CancelModal = ({ setshowPopup, onSubmit }) => {
  const [remarks, setRemarks] = useState('');

  const hidePopup = () => {
    setshowPopup(false);
    stopBackgroundScrolling(false);
  };

  const handleSubmit = () => {
    onSubmit(remarks);
  };

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder">
        <h2>Cancel Order</h2>
        <p>Please share your reason below to cancel the order.</p>
        <TextArea name="demo" label="Reason for cancellation" placeholder="Enter Description" required value={remarks} onChange={(value) => setRemarks(value)} maxLength={150} />
        <div className="characters">&nbsp;</div>
        <div className="buttonSection">
          <button type="button" className="btn activebtn" onClick={hidePopup}>
            Cancel
          </button>
          <button type="button" className="btn activebtn btn-transparent" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelModal;
